import { useRef, useState } from 'react';

import { Button } from '@fragments';
import Popper from '@fragments/Popper';
import { IconPlus, IconSparkles, IconTool } from '@tabler/icons-react';

import AICircle from '@components/AICircle';
import CreateCommunityModal from '@components/_modals/Community/CreateCommunityModal';

import config from '@config';

export default function CreateButton({ fullWidth = false }) {
    const popperRef = useRef();
    const createBtnRef = useRef();

    const [createModalOpen, setCreateModalOpen] = useState(false);

    function handleClick() {
        popperRef.current?.open(
            [
                {
                    id: 'ai',
                    label: 'Criar comunidade com I.A.',
                    icon: <IconSparkles size={16} />,
                    onClick: () => {
                        window.open(config.communityBuilder);
                        popperRef.current?.close();
                    },
                },
                {
                    id: 'manual',
                    label: 'Criar comunidade manualmente',
                    icon: <IconTool size={16} />,
                    onClick: () => {
                        setCreateModalOpen(true);
                        popperRef.current?.close();
                    },
                },
            ],
            'bottom-end',
            createBtnRef.current
        );
    }

    return (
        <>
            <Popper controlRef={popperRef}>
                <span ref={createBtnRef} style={fullWidth ? { width: '100%', display: 'block' } : undefined}>
                    <Button
                        variant="rounded"
                        color="inverse"
                        endIcon={<IconPlus />}
                        onClick={handleClick}
                        tooltip="Criar nova comunidade"
                        startIcon={<AICircle size={26} />}
                        fullWidth={fullWidth}
                    >
                        Criar
                    </Button>
                </span>
            </Popper>

            <CreateCommunityModal
                open={createModalOpen}
                onClose={() => setCreateModalOpen(false)}
            />
        </>
    );
}
